import React from 'react'
import FavPages from './FavPages'
import Search from './Search'
import IssuesHistory from './IssuesHistory'
import ProjectManagement from './ProjectManagement'
import LanguageSwitcher from './LanguageSwitcher'
import Actions from './Actions'
import UserMenu from './UserMenu'
import style from './style.module.scss'

const TopBar = () => {
  return (
    <div className={style.topbar}>
      <div className="mr-4 d-none">
        <FavPages />
      </div>
      <div className="mr-auto d-none">
        <div className="mb-0 d-none">
          <Search />
        </div>
      </div>
      <div className="mr-4 d-none d-md-none">
        <IssuesHistory />
      </div>
      <div className="mb-0 mr-auto d-xl-none d-none">
        <ProjectManagement />
      </div>
      <div className="mr-4 d-none d-sm-none">
        <LanguageSwitcher />
      </div>
      <div className="mr-4 d-none d-sm-none">
        <Actions />
      </div>
      <div className="mr-4 d-none d-sm-none">
        <UserMenu />
      </div>
    </div>
  )
}

export default TopBar
